/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFamilyGameNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFamilyGameNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Play Games Together!",
    "Family Game Night Awaits!",
    "Fun for Everyone!",
  ],
  title: "Family Game Night",
  description: "Organize a fun family game night.",
  longDescription:
    "Gather your family for an exciting game night! Choose a date, decide on games to play, and plan snacks!",
  emoji: "🎲",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Family Game Night",
          emoji: "🎲",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the family game night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on games to play?",
            description: "What games should we focus on during the night?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What games should we consider?",
                emoji: "🃏",
                completeAction: {
                  question: "Decide on snacks?",
                  description:
                    "What snacks should we prepare for the game night?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍿",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let the Games Begin!",
    outroDescription: "Your family game night plans are set! Enjoy the fun!",
  },
};
